import AddIcon from "@assets/icons/plus.svg";
import ChevronDownIcon from "@assets/icons/chevron-down.svg";
import RefreshIcon from "@assets/icons/refresh.svg";

import { cn } from "@utils/tailwind.util";
import { Counter } from "@ui/Counter";
import { SectionHeading } from "@ui/Headings";

interface CollapsibleSectionHeaderProps {
  title: string;
  tagsCount: number;
  isOpen: boolean;
  onToggleSection: () => void;
  onOpenDropdown?: () => void;
  isUpdating?: boolean;
}

export function CollapsibleSectionHeader({
  title,
  tagsCount,
  isOpen,
  onToggleSection,
  onOpenDropdown,
  isUpdating,
}: CollapsibleSectionHeaderProps) {
  return (
    <div className="flex justify-between items-center w-full">
      <div className="flex items-center gap-3">
        <SectionHeading>{title}</SectionHeading>

        {tagsCount > 0 && <Counter value={tagsCount} />}
        {onOpenDropdown && (
          <span className="ml-1 flex items-center cursor-pointer w-8 h-8" onClick={onOpenDropdown}>
            <AddIcon width={20} height={20} className="text-content-secondary flex-shrink-0" />
          </span>
        )}
      </div>

      <div className="flex items-center gap-2">
        {isUpdating && (
          <div className="flex items-center gap-1">
            <div className="animate-slowspin flex items-center">
              <RefreshIcon width={12} height={12} className="text-content-secondary stroke-1" />
            </div>
            <span className="text-sm font-normal text-content-secondary">Updating…</span>
          </div>
        )}

        {tagsCount > 0 && !isUpdating && (
          <ChevronDownIcon
            color="#6B7080"
            width={20}
            height={20}
            className={cn(
              "transition-transform duration-300 cursor-pointer flex-shrink-0",
              isOpen ? "rotate-0" : "-rotate-90"
            )}
            onClick={onToggleSection}
          />
        )}
      </div>
    </div>
  );
}
